import { render, staticRenderFns } from "./PostCompose.vue?vue&type=template&id=f2649e44&"
import script from "./PostCompose.vue?vue&type=script&lang=js&"
export * from "./PostCompose.vue?vue&type=script&lang=js&"
import style0 from "./PostCompose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports